import o from"./localization.js";import a from"./localization2.js";import n from"./localization3.js";const r={$lang:"en-US",$name:"English",$dir:"ltr","nord-command-menu":o,"nord-calendar":n,"nord-date-picker":a};export{r as default};
//# sourceMappingURL=en-us.js.map
